import { render, staticRenderFns } from "./UsuarioCadastro.vue?vue&type=template&id=3a3c3ee6&"
import script from "./UsuarioCadastro.vue?vue&type=script&lang=js&"
export * from "./UsuarioCadastro.vue?vue&type=script&lang=js&"
import style0 from "./UsuarioCadastro.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports